import { stringify } from 'hub-http/helpers/params';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { Flow } from 'signup-constants/Flow';
import { SignupUrlGenerator } from 'signup-ui-url-generator/SignupUrlGenerator';
export const getRootUrl = () => {
  const path = /^\/ecosystem\/\d+\/marketplace\/website/.test(window.location.pathname) ? 'website' : 'assets';
  return `/ecosystem/${PortalIdParser.get()}/marketplace/${path}`;
};
export const getEmbedRootUrl = () => `/ecosystem/${PortalIdParser.get()}/marketplace-embed/assets`;
export const getPublicRootUrl = lang => {
  const publicRoot = '/marketplace/website';

  switch (lang) {
    case 'pt':
    case 'pt-br':
      return `/pt${publicRoot}`;

    case 'ja':
    case 'jp':
      return `/ja${publicRoot}`;

    case 'de':
    case 'es':
    case 'fr':
      return `/${lang}${publicRoot}`;

    default:
      return publicRoot;
  }
};
export const getDownloadedAssetsUrl = (isPublic = false) => {
  if (isPublic) {
    return `${getFullUrl('app', {
      hubletOverride: na1
    })}/l/marketplace-settings/downloads/theme`;
  }

  return `${getFullUrl('app')}/marketplace-settings/${PortalIdParser.get()}/downloads/theme`;
};
export const getDownloadedAssetsSuccessUrl = params => `${getDownloadedAssetsUrl()}?${stringify(params)}`;
export const getDownloadedAssetsUpdateUrl = offeringId => `${getDownloadedAssetsUrl()}?updateOfferingId=${offeringId}`;
export const getPublicDetailPageFullUrl = (lang, slug) => {
  return `${getFullUrl('ecosystem', {
    hubletOverride: 'na1'
  })}${getPublicRootUrl(lang)}/${slug}`;
};
export const getDetailsPageShortUrl = (lang, slug) => {
  return `${getFullUrl('app', {
    hubletOverride: 'na1'
  })}/l/ecosystem/marketplace/website/${slug}`;
};
export const getDetailPageFullUrl = slug => {
  return `${getFullUrl('app', {
    hubletOverride: na1
  })}/ecosystem/${PortalIdParser.get()}/marketplace/assets/themes/${slug}`;
};
export const getLoginUrl = () => `${getFullUrl('app', {
  hubletOverride: na1
})}/login`;
export const getAssetShortlink = (pathname, params = {}) => {
  return `${getFullUrl('app', {
    hubletOverride: na1
  })}/l/ecosystem/marketplace/assets${pathname}${Object.keys(params).length ? `?${stringify(params)}` : ''}`;
};

const getPublicLangUrl = langUrlMap => {
  // @ts-expect-error untyped dependency
  const lang = I18n.loaded ? getLang() : 'en';
  return lang in langUrlMap ? langUrlMap[lang] : langUrlMap.en;
};

export const getHubSpotFreeLink = (params = {}) => {
  return `https://www.hubspot.com/products/get-started${Object.keys(params).length ? `?${stringify(params)}` : ''}
  `;
};
export const getCmsHubPricingUrl = () => 'https://www.hubspot.com/pricing/cms';
export const getCmsHubProductUrl = () => getPublicLangUrl({
  en: 'https://www.hubspot.com/products/cms',
  de: 'https://www.hubspot.de/products/cms',
  es: 'https://www.hubspot.es/products/cms',
  fr: 'https://www.hubspot.fr/products/cms',
  ja: 'https://www.hubspot.jp/products/cms',
  pt: 'https://br.hubspot.com/products/cms'
});
export const getMarketingHubPricingUrl = () => 'https://www.hubspot.com/pricing/marketing';
export const getAssetsBuildButtonUrl = () => {
  return new SignupUrlGenerator(Flow.AssetProvider).getUrl();
};
export const getFullPublicUrl = (lang, useLocal) => {
  return `${getFullUrl(useLocal ? 'local' : 'ecosystem', {
    hubletOverride: 'na1'
  })}${getPublicRootUrl(lang)}`;
};
export const getAppShortUrl = () => `${getFullUrl('app', {
  hubletOverride: 'na1'
})}/l/ecosystem/marketplace/website`;